import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  const { primary, secondary } = theme.palette;
  const { yellow } = theme.palette.common;

  return {
    Button: {
      'minWidth': 'min-content',
      'position': 'relative',
      'borderRadius': '25px',
      'padding': '0 20px',
      'boxSizing': 'border-box',
      'textTransform': 'none',
      'justifyContent': 'center',

      '&.Button--icon.Button--large': {
        padding: '0',
        width: '50px',
        height: '50px',
      },
      '&.Button--icon.Button--standard': {
        padding: '0',
        width: '35px',
        height: '35px',
      },
      '&.Button--icon.Button--small': {
        'padding': '0 3px',
        'width': '25px',
        'height': '25px',
        '& svg': {
          width: '14px',
          height: '14px',
        },
      },
      '&.Button--icon.Button--wide': {
        padding: '0 14px',
        height: '35px',
      },
    },
    Button_primary: {
      'backgroundColor': primary.idle,
      'border': `2px solid ${primary.idle}`,
      '&:hover': {
        backgroundColor: primary.hover,
        borderColor: primary.hover,
      },
      '&.Button--focused': {
        boxShadow: `inset 0 0 1px 1px ${primary.disabled}`,
        backgroundColor: primary.pressed,
        borderColor: primary.pressed,
      },
      '&.Button--pressed': {
        backgroundColor: primary.pressed,
        borderColor: primary.pressed,
      },
    },
    Button_secondary: {
      'backgroundColor': secondary.idle,
      'border': `2px solid ${secondary.idle}`,
      '&:hover': {
        backgroundColor: secondary.hover,
        borderColor: secondary.hover,
      },
      '&.Button--focused': {
        boxShadow: `inset 0 0 1px 1px ${secondary.disabled}`,
        backgroundColor: secondary.pressed,
        borderColor: secondary.pressed,
      },
      '&.Button--pressed': {
        backgroundColor: secondary.pressed,
        borderColor: secondary.pressed,
      },
    },
    Button_active: {
      'backgroundColor': yellow,
      'border': `2px solid ${yellow}`,
      '&.Button--primary:hover': {
        backgroundColor: yellow,
        borderColor: yellow,
      },
      '&.Button--primary.Button--focused': {
        backgroundColor: yellow,
        borderColor: yellow,
      },
    },
    Button_outlined: {
      'backgroundColor': 'transparent',
      '&.Button--focused': {
        backgroundColor: 'transparent',
      },
      '&.Button--focused::before': {
        content: '""',
        boxSizing: 'border-box',
        borderRadius: '25px',
        width: '98%',
        height: '92%',
        position: 'absolute',
        left: '1%',
        top: '4%',
      },
      '&.Button--focused:hover': {
        boxShadow: 'none',
      },
      '&.Button--focused:hover::before': {
        display: 'none',
      },
      '&.Button--focused.Button--primary::before': {
        border: `1px solid ${primary.disabled}`,
      },
      '&.Button--focused.Button--primary:hover': {
        backgroundColor: primary.hover,
      },
      '&.Button--focused.Button--primary.Button--pressed': {
        backgroundColor: primary.pressed,
      },
      '&.Button--focused.Button--secondary::before': {
        border: `1px solid ${secondary.disabled}`,
      },
      '&.Button--focused.Button--secondary:hover': {
        backgroundColor: secondary.hover,
      },
      '&.Button--focused.Button--secondary.Button--pressed': {
        backgroundColor: secondary.pressed,
      },
    },
    Button_text: {
      'backgroundColor': 'transparent',
      'border': 'none',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&.Button--focused': {
        backgroundColor: 'transparent',
      },
      '&.Button--focused:hover': {
        boxShadow: 'none',
      },
    },
    Button_small: {
      minHeight: '25px',
    },
    Button_standard: {
      minHeight: '35px',
    },
    Button_large: {
      minHeight: '50px',
    },
    Typography: {
      'color': '#ffffff',
      'fontFamily': 'Quicksand',
      'fontWeight': 'bold',
      '&.Typography--hover': {
        color: '#ffffff',
      },
      '&.Typography--link': {
        color: secondary.idle,
        textDecoration: 'underline',
        fontSize: 10,
      },
    },
    Typography_primary: {
      '&.Typography--outlined': {
        'color': primary.idle,
        '&.Typography--hover': {
          color: '#ffffff',
        },
        '&.Typography--hover.Typography--focus': {
          color: '#ffffff',
        },
      },
    },
    Typography_secondary: {
      '&.Typography--outlined': {
        'color': secondary.idle,
        '&.Typography--hover': {
          color: '#ffffff',
        },
        '&.Typography--hover.Typography--focus': {
          color: '#ffffff',
        },
      },
    },
    Typography_small: {
      fontSize: 12,
    },
    Typography_standard: {
      fontSize: 14,
    },
    Typography_large: {
      fontSize: 18,
    },

    Button__Icon: {
      'margin-right': '7px',
      'fill': '#ffffff',
      '&.Button__Icon--small': {
        width: '16px',
        height: '16px',
      },
    },
    Button__Icon_only: {
      marginRight: '0',
    },
  };
});
